import { render, staticRenderFns } from "./CustomersDetail.vue?vue&type=template&id=3950c756&lang=html&"
import script from "./CustomersDetail.vue?vue&type=script&lang=js&"
export * from "./CustomersDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports